import { Component, OnInit, AfterViewInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { AuthService } from '../../lib/auth.service';
import { Router } from '@angular/router';
import { ModalService } from '../../lib/modal.service';
import { UserService } from '../../lib/user.service';
import { MoodcheckModalComponent } from '../../components/moodcheck-modal/moodcheck-modal.component';
import { StorageService } from '../../lib/storage.service';
import { ApiService } from '../../lib/api.service';
import { TutorialPage } from '../../components/tutorial/tutorial';
import { config } from '../../../environments/all';
import { User } from '../../models/user';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '../../lib/log.service';
import { DynamicFormComponent } from "app/components/dynamic-form/dynamic-form.component";
import { environment } from '../../../environments/environment';
import { UtilityService } from '../../lib/utility.service';
import { PermissionsService } from '../../lib/permissions.service';
import { SupportComponent } from '../../components/support/support';
import { MenuService } from '../../lib/menu.service';
import { ConsentModalComponent } from 'app/components/consent-modal/consent-modal.component';
import { SafeRedirect } from '../../lib/safe-redirect';


declare var jQuery: any;

@Component({
    selector: 'app-auth-portal',
    templateUrl: './auth-portal.component.html',
    styleUrls: ['./auth-portal.component.scss'],
    standalone: false
})
export class AuthPortalTemplate implements AfterViewInit, OnInit {

	navIn: boolean;
	userType: string;
	playStore: string;
	appStore: string;
	user: User;
	english: boolean = true;
	enableResources: boolean = false;
	enableMessages: boolean = false;
	hasCounselors: boolean = true;
	userDetailsShow: boolean = false;
	practiceShow: boolean = true;
	theoryShow: boolean = true;
	moodcheckShow: boolean = true;
	assessmentShow: boolean = true;
	calendarShow: boolean = true;
	disabled: boolean = false;
	modal: any;
	locked: boolean = true;
	messagesActive: boolean = false;
	pathActive: string = '';
	demoMode: boolean = false;
	demoClose: boolean = false;
	showDemoClose: boolean = false;
	showCalendar: boolean;
	defaultAssessment: string;
	disableLanguage: boolean;

	constructor(
		private auth: AuthService,
		private router: Router,
		private storage: StorageService,
		private modalService: ModalService,
		private userService: UserService,
		private translate: TranslateService,
		private logService: LogService,
		private api: ApiService,
		private utilityService: UtilityService,
		private permissionService: PermissionsService,
		private menuService: MenuService
	) {

		this.navIn = false;
		this.user = this.userService.getUser();

		this.appStore = config.appStore;
		this.playStore = config.playStore;

		this.userService.watcher.subscribe((user: User) => {
			this.user = user;
			(this.user.isFullAccess || this.user.userType === 'admin') ? this.locked = false : this.locked = true;
			this.initPermissions();
		});
		this.userType = this.user.userType;
		this.pathActive = this.router.url;

		this.demoMode = this.utilityService.isDemoMode();

	}

	ngOnInit() {
		this.permissionService.setUser(this.user);
		this.initPermissions();
	}

	initPermissions() {

		this.disableLanguage = false;
		this.defaultAssessment = 'das';

		if (this.user.primaryOrganization) {
			if (this.user.primaryOrganization.enableResources) {
				this.enableResources = this.user.primaryOrganization.enableResources;
			}

			if (this.user.primaryOrganization.settings && this.user.primaryOrganization.settings.hasCounselors) {
				this.hasCounselors = this.user.primaryOrganization.settings.hasCounselors;
			}

			if (this.user.primaryOrganization.settings && this.user.primaryOrganization.settings.enableMessages) {
				this.enableMessages = this.user.primaryOrganization.settings.enableMessages;
			}

		}

		(this.user.isFullAccess || this.user.userType === 'admin') ? this.locked = false : this.locked = true;
	}

	ngAfterViewInit() {
		this.translate.stream('lang').subscribe((res: any) => {
			if (res === 'en') {
				this.english = true;
			} else {
				this.english = false;
			}
		});
		//Close the menu when a link is clicked
		jQuery(document).ready(() => {
			jQuery('#nav li a').click(() => {
				this.navIn = false;
			});
		});
	}

	onMoodCheck() {
		//show moodcheck tutorial

		if (this.locked) {
			this.ondisabled();
		} else if (this.user.userType === 'user' && this.user.showDemographic) {
			setTimeout(() => {
				this.modalService.setCloseOnClickAway(false);
				this.modalService.showComponent(TutorialPage, 'assessmentforce');
			}, 500);
		} else if (!this.storage.checkFlag('finished-tutorial-moodcheck')) {
			this.modalService.showComponent(TutorialPage, 'moodcheck').afterClosed().subscribe(result => {
				this.displayMoodcheck();
			});

		} else {
			this.displayMoodcheck();
		}
	}

	displayMoodcheck() {
		this.router.navigateByUrl('/app/mood-check');
	}

	onInviteUser() {

	}

	onNavToggle() {
		this.navIn = !this.navIn;
		if (this.navIn) {
			setTimeout(function () {
				jQuery('nav a').first().focus();
			}, 500);
		} else {
			setTimeout(function () {
				jQuery('.navbar-toggle').focus();
			}, 500);
		}
	}

	onNavClose() {
		this.navIn = false;
		setTimeout(function () {
			jQuery('.navbar-toggle').focus();
		}, 500);
	}

	onLogout() {
		let url = '/';
		if (this.user.primaryOrganization) {
			if (environment.production) {
				let subdomain = this.user.primaryOrganization.subdomain;
				let domain = environment.domain;
				
				if (subdomain) {
					//have to put in temporary measure until welltrack-boost.com is registered with wtc
					if(subdomain === 'canada'){
						url = 'https://' + subdomain + '.' + 'welltrack.com';
					}
					else{
						url = 'https://' + subdomain + '.' + domain;
					}
				} else {
					url = 'https://' + 'app' + '.' + domain;
				}
			}
		}
		if (this.demoMode) {
			this.auth.logout();
			window.open(url, '_self');
		} else {
			this.api.post('users/logout', {}).subscribe(
				(result: any) => {
					if (result.data && result.data.hasOwnProperty("logoutLink")) {
						let urlRedirect = decodeURIComponent(result.data.logoutLink);
						SafeRedirect.open(urlRedirect, '_self', true);
					}
					else {
						SafeRedirect.open(url, '_self', true);
					}
					this.auth.logout();
				},
				(error: any) => {
					this.auth.logout();
					window.open(url, '_self');
				}
			);
		}
	}

	nav(path) {

		this.messagesActive = false;
	
		let allowedUrls = (path === '/app' || path === '/' || path.search('settings') !== -1 || path.search('support') !== -1);
		const serviceType = this.user.organizations.find(x => x.serviceType === 1);
		if (this.user.userType === 'admin' || path.search('settings') !== -1 || path.search('emergency-contact') !== -1) {
			this.pathActive = path;
			setTimeout(() => {
				this.router.navigate([path]);
				this.onNavClose();
			}, 100);
		}
		else if(serviceType && serviceType.settings && serviceType.settings.enableAlerts && this.user.preferences.consent === null){
			setTimeout(() => {
				this.modalService
					.showComponent(ConsentModalComponent, null, "", true)
					.afterClosed()
					.subscribe((result) => {
						setTimeout(() => {
							this.router.navigate([path]);
							this.onNavClose();
						}, 100);
					});
			}, 500);
		}
		else if (!this.demoMode && this.user.userType === 'user' && this.user.showDemographic && !allowedUrls) {
			setTimeout(() => {
				this.router.navigate(['/app/surveys',this.user.demographicFormId, 'Demographic'], { queryParams:  null });
			});
		}
		else if (!this.demoMode && !this.locked &&  this.user.userType === 'user' && this.user.forceAssessment) {
			if (path.search('assessment') === -1) {
				setTimeout(() => {
					this.modalService.showComponent(TutorialPage, 'assessmentforce', '', true);
				}, 500);
			}
		} else if (allowedUrls) {
			this.pathActive = path;
			setTimeout(() => {
				this.router.navigate([path]);
				this.onNavClose();
			}, 100);
		} else if (this.locked) {
			this.ondisabled();
		} else {
			this.pathActive = path;
			setTimeout(() => {
				this.router.navigate([path]);
				this.onNavClose();
			}, 100);
		}
	}

	ondisabled() {
		this.modalService.showAlert("Error", 'You must associate your account with an organization to access all of WellTrack\'s features. Please go to "My settings".');
	}

	onDemoClose() {
		this.demoClose = true;
	}

	onSupportClick() {
		this.modalService.showComponent(SupportComponent, {}, "app-c-modal--cure");
	}

	onSkipNav() {
		setTimeout(function () {
			jQuery('#page a').eq(1).focus();
		}, 500);

	}
}
